import { useNavigate } from "react-router";

import { ResultButton } from "@/components/organisms/Result";
import { ResultBlocker } from "@/components/organisms/Result/ResultBlocker";
import { PathNamekRoutes } from "@/router";

import { isInIframe } from "../helpers/isInIframe";

const UnauthorizedInFrame = () => {
  return (
    <div className="flex h-full w-full flex-col items-center justify-center">
      <ResultBlocker
        status="unauthorized"
        subTitle="Por favor, recargue la página. Si el problema persiste, comunicate con soporte."
        title="Ocurrió un error al intentar autenticarse desde el portal"
      />
    </div>
  );
};

const UnauthorizedIDev = () => {
  const navigate = useNavigate();
  const goToLogin = () => {
    navigate(`/${PathNamekRoutes.LOGIN}`, {
      replace: true,
    });
  };

  return (
    <div className="flex h-full w-full flex-col items-center justify-center">
      <ResultBlocker status="unauthorized">
        <ResultButton onClick={goToLogin}>Volver al inicio</ResultButton>
      </ResultBlocker>
    </div>
  );
};

const Unauthorized = () => {
  return isInIframe() ? <UnauthorizedInFrame /> : <UnauthorizedIDev />;
};

export default Unauthorized;
